export default __webpack_public_path__ + "static/media/Sarabun-Thin.15b15133.ttf";